import {createContext} from 'react';

export const ButtonNext = createContext(true);